<template>
  <div v-if="show && hasSocialProviders" class="social-auth-buttons text-center">
    <div v-if="showTitle" class="mb-3 social-title">
      <span>{{ $t(titleKey) }}</span>
    </div>

    <ul class="mb-3 list-unstyled">
      <li v-if="isProviderEnabled('google')">
        <GoogleLoginButton @success="emitSuccess" @error="handleError" />
      </li>
      <li v-if="isProviderEnabled('apple') && !isAppleDisabled">
        <AppleLoginButton @success="emitSuccess" @error="handleError" />
      </li>
      <li v-if="isProviderEnabled('facebook')">
        <FacebookLoginButton @success="emitSuccess" @error="handleError" />
      </li>
    </ul>

    <span
      v-if="socialError"
      class="social-auth-buttons--error-message text-danger small d-block"
    >
      {{ $t(errorMessageKey) }}
    </span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GoogleLoginButton from '@/domain/auth/components/providers/GoogleLoginButton.vue'
import FacebookLoginButton from '@/domain/auth/components/providers/FacebookLoginButton.vue'
import AppleLoginButton from '@/domain/auth/components/providers/AppleLoginButton.vue'

export default {
  name: 'SocialAuthButtons',
  components: { GoogleLoginButton, FacebookLoginButton, AppleLoginButton },
  props: {
    show: { type: Boolean, default: true },
    showTitle: { type: Boolean, default: true },
    errorMessageKey: { type: String, default: 'forms.login_form.social_login_error' },
    titleKey: { type: String, default: 'forms.login_form.social_login_title' },
    appleDisabled: { type: Boolean, default: null }
  },
  data() {
    return { socialError: false }
  },
  computed: {
    ...mapGetters(['disableSocialLoginInPreview']),
    ...mapGetters('auth', ['isAuthProviderEnabled']),

    isAppleDisabled() {
      return this.appleDisabled === null ? this.disableSocialLoginInPreview : this.appleDisabled
    },

    hasSocialProviders() {
      return (
        this.isProviderEnabled('google') ||
        this.isProviderEnabled('facebook') ||
        (this.isProviderEnabled('apple') && !this.isAppleDisabled)
      )
    }
  },
  methods: {
    isProviderEnabled(provider) {
      return this.isAuthProviderEnabled(provider)
    },
    emitSuccess(payload) {
      this.$emit('success', payload)
    },
    handleError(err) {
      this.socialError = true
      this.$emit('error', err)
      setTimeout(() => { this.socialError = false }, 5000)
    }
  }
}
</script>
